module.exports = __webpack_public_path__ + "static/hero-gradient-f527e14952fa10c1e2f3971a7091927b.png";